import { Chevron } from '@hendrx/icons/Chevron';
import { Select as MantineSelect } from '@mantine/core';
import cx from 'clsx';
import { ComponentProps, forwardRef, useState } from 'react';

import classes from './Select.module.scss';

export const Select = forwardRef<HTMLInputElement, ComponentProps<typeof MantineSelect>>(function (props, ref) {
  const [isOpen, setIsOpen] = useState(false);

  const { classNames, ...otherProps } = props;

  return (
    <MantineSelect
      onDropdownOpen={() => setIsOpen(true)}
      onDropdownClose={() => setIsOpen(false)}
      comboboxProps={{ withinPortal: false }}
      rightSection={<Chevron className={cx(classes.chevron, { [classes.open]: isOpen })} />}
      classNames={{
        ...classNames,
        option: cx(typeof classNames === 'object' && classNames?.option, props.renderOption && classes.optionWrapper),
        dropdown: cx(typeof classNames === 'object' && classNames?.dropdown, classes.dropdown)
      }}
      {...otherProps}
      ref={ref}
    />
  );
});
